import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useApi from "../../hooks/useApi";

import { getDecodedToken } from "../../utils/helpers";
import { formatDate } from "../../utils/helpers";

import Loader from "../../Components/Loader";

import "./style.scss";

const ConsumerRequests = () => {
  const [requestsData, setRequestsData] = useState();

  const { get, loading } = useApi();
  const { t } = useTranslation();

  const fetchRequests = async () => {
    try {
      const data = await get(
        `/Providers/Consumer/Requests?ConsumerId=${getDecodedToken().buid}&Statuses=Pending`,
      );

      setRequestsData(data);
    } catch (err) {
      console.log(err);
    }
  };

  console.log(requestsData);

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <div className="consumer-request-container">
      <div className="requests-container-header">
        <h2>{t("your_pending_requests")}</h2>
      </div>

      <div className={`requests-cards`}>
        {requestsData && requestsData.length ? (
          requestsData.map((item) => {
            return (
              <div className="requests-card-wraper" key={item.id}>
                <div className="card-info">
                  <span>{t("name")}:</span>
                  <span>{item.providerName}</span>
                </div>

                <div className="card-info">
                  <span>{t("requested_at")}:</span>
                  <span>{formatDate(item.creationDate, t)}</span>
                </div>

                {item.description === "" ? null : (
                  <div className="card-notes">
                    <span className="time-notes-header">
                      {t("additional_text")}
                    </span>
                    <div className="notes">
                      <span>{item.description}</span>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="empty_requests">
            <h2>{t("empty_pending_requests")}</h2>
          </div>
        )}
      </div>

      {loading && <Loader />}
    </div>
  );
};

export default ConsumerRequests;
